"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const router_1 = require("next/router");
const lib_1 = require("../lib");
const TrackNextRouter = () => {
    const router = (0, router_1.useRouter)();
    const capture = (0, lib_1.useCapture)();
    (0, react_1.useEffect)(() => {
        // Track page views
        const pageLeave = () => {
            capture("$pageleave");
        };
        const pageView = () => {
            capture("$pageview");
        };
        router.events.on("routeChangeStart", pageLeave);
        router.events.on("routeChangeComplete", pageView);
        pageView();
        return () => {
            router.events.off("routeChangeStart", pageLeave);
            router.events.off("routeChangeComplete", pageView);
        };
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [capture]);
    return null;
};
exports.default = TrackNextRouter;
